export default __webpack_public_path__ + "static/media/TRX-BNB.3227ee5c.svg";